import { useToast } from '../../../contexts/ToastContext'
import { Address } from '../../../shared/types/battery'

interface UseCheckoutValidationProps {
  shippingAddress: Address
  isAuthenticated: boolean
  hasUser: boolean
  setFormErrors: (errors: Record<string, string>) => void
}

export const useCheckoutValidation = ({
  shippingAddress,
  isAuthenticated,
  hasUser,
  setFormErrors
}: UseCheckoutValidationProps) => {
  const { addToast } = useToast()

  const validateStep1 = (): boolean => {
    const errors: Record<string, string> = {}

    if (!shippingAddress.zipCode) errors.zipCode = 'CEP é obrigatório'
    if (!shippingAddress.street) errors.street = 'Rua é obrigatória'
    if (!shippingAddress.number) errors.number = 'Número é obrigatório'
    if (!shippingAddress.neighborhood) errors.neighborhood = 'Bairro é obrigatório'
    if (!shippingAddress.city) errors.city = 'Cidade é obrigatória'
    if (!shippingAddress.state) errors.state = 'Estado é obrigatório'

    setFormErrors(errors)

    if (Object.keys(errors).length > 0) {
      // Verifica se todos os campos estão vazios para dar uma mensagem mais genérica
      const isFormEmpty = !shippingAddress.zipCode &&
        !shippingAddress.street &&
        !shippingAddress.number &&
        !shippingAddress.neighborhood &&
        !shippingAddress.city &&
        !shippingAddress.state

      if (isFormEmpty) {
        addToast({
          type: 'error',
          title: 'Endereço necessário',
          message: 'Selecione ou preencha um endereço'
        })
      } else {
        addToast({
          type: 'error',
          title: 'Campos obrigatórios',
          message: 'Preencha todos os campos obrigatórios do endereço'
        })
      }
      return false
    }

    return true
  }

  const validateStep2 = (): boolean => {
    // Verificar se está autenticado
    if (!isAuthenticated || !hasUser) {
      addToast({
        type: 'error',
        title: 'Autenticação necessária',
        message: 'Você precisa estar logado para continuar'
      })
      return false
    }

    return true
  }

  return {
    validateStep1,
    validateStep2
  }
}

